import type { FollowingListUsersOrderOptions } from '@/modules/chatting/types'

export const followingListUsersOrderOptions: {
  label: string
  value: FollowingListUsersOrderOptions
}[] = [
  { label: 'Recent', value: 'last_activity' },
  { label: 'Current subscription', value: 'expire_date' },
  { label: 'Started', value: 'subscribe_date' },
]
